<div class="app-bookmarks-dialog">
  <div class="header">
    <button mat-icon-button class="back-button" (click)="close()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h3>Location</h3>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content">
    <div class="map-container">
      <div id="mapSelector" style="height: 625px; width: 100%"></div>
      <div class="marker">
        <img src="assets/map/icons/DefaultMarker.svg" alt="marker" />
      </div>
    </div>
    <div class="reset-button-container">
      <button (click)="resetMap()" [disabled]="!resetButton" mat-button color="primary">Reset map</button>
    </div>

    <div class="action-buttons">
      <button mat-button type="button" (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" (click)="save()">Save</button>
    </div>
  </div>
</div>
